import Loki from './Loki.component';

export default Loki;